// extracted by mini-css-extract-plugin
module.exports = {"root":"userStatistic_root__2DQf9","child":"userStatistic_child__-N2Jq"};